export enum OrganizationTitle
{
  MPO="mit.MPO",
  MusicNest="myMusicNest"
}